import { render, staticRenderFns } from "./DynamicGraph.vue?vue&type=template&id=50747a95&scoped=true&"
import script from "./DynamicGraph.vue?vue&type=script&lang=js&"
export * from "./DynamicGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50747a95",
  null
  
)

export default component.exports